import React from 'react';
import { motion } from 'framer-motion';
export function ForWhoSection() {
  return <section className="bg-gradient-hero pt-4 pb-12 md:pt-6 md:pb-16 px-4 md:px-8" data-id="element-118">
      <div className="max-w-5xl mx-auto" data-id="element-119">
        {/* Logo */}
        <div className="flex justify-center mb-6" data-id="element-120">
          <img src="https://cdn.magicpatterns.com/uploads/8oPA5XWTq8ReZrtFKXRt8o/cosmos-image-1775180050400.png" alt="Protocolo H.E.R. Logo" className="w-24 md:w-32 h-auto" data-id="element-121" />
        </div>

        {/* Qué recibís al entrar */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} className="max-w-3xl mx-auto mt-12" data-id="element-122">
          <h3 className="text-2xl md:text-3xl font-display font-bold text-center mb-2" style={{
          color: '#E8D5B0'
        }} data-id="element-123">
            Qué recibís al entrar
          </h3>
          <p className="text-base md:text-lg font-body font-medium text-center mb-8 max-w-xl mx-auto leading-relaxed" style={{
          color: 'rgba(255, 255, 255, 0.75)'
        }} data-id="element-124">
            Todo lo que necesitás para empezar hoy, sin pensar ni improvisar.
          </p>

          <div className="space-y-4" data-id="element-125">
            {[{
            title: 'Plan de 21 días paso a paso',
            desc: 'Sabés exactamente qué hacer cada día para desinflamar tu cuerpo sin improvisar.'
          }, {
            title: 'Guía simple para seguir sin pensar',
            desc: 'No necesitás contar calorías ni armar dietas: seguís el sistema.'
          }, {
            title: '63 comidas antiinflamatorias',
            desc: 'Opciones reales para reducir la hinchazón sin hacer dietas restrictivas.'
          }, {
            title: 'Rutinas cortas (15–25 min)',
            desc: 'Movimiento diseñado para activar tu metabolismo sin agotarte.'
          }, {
            title: 'Tracker de progreso (2 min por día)',
            desc: 'Para ver cambios reales en energía, inflamación y medidas.'
          }].map((item, i) => <motion.div key={i} initial={{
            opacity: 0,
            x: -15
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.4,
            delay: i * 0.1
          }} className="flex items-start gap-4 bg-card border border-border rounded-xl py-5 px-5 hover:border-gold/30 transition-colors" data-id="element-126">
                <span className="text-gold text-xl mt-0.5" data-id="element-127">✓</span>
                <div data-id="element-128">
                  <p className="font-display font-bold text-lg leading-snug" style={{
                color: '#E8D5B0'
              }} data-id="element-129">
                    {item.title}
                  </p>
                  <p className="text-sm md:text-[15px] font-medium font-body mt-1.5 leading-relaxed" style={{
                color: 'rgba(232, 213, 176, 0.8)'
              }} data-id="element-130">
                    {item.desc}
                  </p>
                </div>
              </motion.div>)}
          </div>
        </motion.div>

        {/* Cómo se usa (en 3 pasos) */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} className="max-w-3xl mx-auto mt-12" data-id="element-131">
          <h3 className="text-2xl md:text-3xl font-display font-bold text-center mb-3" style={{
          color: '#E8D5B0'
        }} data-id="element-132">
            Cómo se usa (en 3 pasos)
          </h3>

          <p className="text-base md:text-lg font-body font-medium text-center mb-8 max-w-xl mx-auto leading-relaxed" style={{
          color: 'rgba(255, 255, 255, 0.8)'
        }} data-id="element-133">
            Esto no es una dieta complicada. Es un sistema simple que podés
            seguir incluso con trabajo, familia y poco tiempo.
          </p>

          <div className="space-y-3 md:space-y-4" data-id="element-134">
            {[{
            step: '1',
            text: 'Elegís tu fase (H/E/R) y seguís el día correspondiente.'
          }, {
            step: '2',
            text: 'Comés con el recetario (sin contar calorías ni improvisar).'
          }, {
            step: '3',
            text: 'Rutina 15–25 min + tracker 2 min para sostener constancia.'
          }].map((item, i) => <motion.div key={i} initial={{
            opacity: 0,
            x: -15
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.4,
            delay: i * 0.15
          }} className="flex items-center gap-3 md:gap-4 bg-card border border-border rounded-xl py-3 px-4 md:py-5 md:px-5 hover:border-gold/30 transition-colors" data-id="element-135">
                <span className="text-xl md:text-2xl font-display font-bold flex-shrink-0 leading-none" style={{
              color: '#E8D5B0'
            }} data-id="element-136">
                  {item.step}
                </span>
                <p className="font-body font-medium text-base md:text-lg leading-snug md:leading-relaxed" style={{
              color: 'rgba(255, 255, 255, 0.9)'
            }} data-id="element-137">
                  {item.text}
                </p>
              </motion.div>)}
          </div>
        </motion.div>
      </div>
    </section>;
}